import {withAuthenticator} from 'components/Auth';
import {lazyWithPreload} from 'lib/utils';

const LazyApp = lazyWithPreload(() => import(/* webpackChunkName: "app" */ './App'));

export default withAuthenticator(LazyApp);
